import {Locale} from "next-intl";
import {SettingsNavigationProperty} from "@pata/settings";
import {getLocale, getTranslations} from "next-intl/server";

export default async function fetchServices(): Promise<SettingsNavigationProperty[]> {
    const locale: Locale = await getLocale()
    const t = await getTranslations('Navigation')
    
    switch (locale) {
        default:
            return [
                { name: t("shop"), path: "https://patatimber.lv/", htmlId: 1136 },
                { name: t("forest-management"), path: "/forest-management", htmlId: 53 },
                { name: t("transport-and-logistics"), path: "/transport-and-logistics", htmlId: 52 },
                { name: t("timber-industry"), path: "/timber-industry", htmlId: 55 },
                { name: t("logging"), path: "/logging", htmlId: 56 },
                { name: t("financing"), path: "/financing", htmlId: 54 },
                { name: t("energy"), path: "/energy", htmlId: 626 },
            ]
        case "en":
            return [
                { name: t("round-timber-trade"), path: "/round-timber-trade", htmlId: 1142 },
                { name: t("shop"), path: "https://patatimber.lv/", htmlId: 629 },
                { name: t("energy"), path: "/energy", htmlId: 634 },
                { name: t("forest-management"), path: "/forest-management", htmlId: 1140 },
            ]
        case "lt":
            return [
                { name: t("forest-management"), path: "/forest-management", htmlId: 1670 },
                { name: t("logging"), path: "/logging", htmlId: 1671 },
                { name: t("shop"), path: "https://patatimber.lv/", htmlId: 1672 },
                { name: t("timber-industry"), path: "/timber-industry", htmlId: 1673 },
                { name: t("energy"), path: "/energy", htmlId: 1674 },
                { name: t("transport-and-logistics"), path: "/transport-and-logistics", htmlId: 1675 },
                { name: t("sawn-wood-trade"), path: "/sawn-wood-trade", htmlId: 1676 },
                { name: t("round-timber-trade"), path: "/round-timber-trade", htmlId: 1677 },
                { name: t("financing"), path: "/financing", htmlId: 1678 },
            ]
        case "cn":
            return [
                { name: t("forest-management"), path: "/forest-management", htmlId: 1432 },
                { name: t("logging"), path: "/logging", htmlId: 1433 },
                { name: t("shop"), path: "https://patatimber.lv/", htmlId: 1434 },
                { name: t("timber-industry"), path: "/timber-industry", htmlId: 1435 },
                { name: t("energy"), path: "/energy", htmlId: 1436 },
                { name: t("transport-and-logistics"), path: "/transport-and-logistics", htmlId: 1437 },
                { name: t("sawn-wood-trade"), path: "/sawn-wood-trade", htmlId: 1438 },
                { name: t("round-timber-trade"), path: "/round-timber-trade", htmlId: 1439 },
                { name: t("financing"), path: "/financing", htmlId: 1440 },
            ]
    }
}